<template>
  <component :is="tag">
    <slot name="trigger" v-bind="{ isOpen, toggle }" />
    <slot name="collapsible" v-bind="{ isOpen }" />
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },

  data () {
    return {
      isOpen: false,
    }
  },

  methods: {
    toggle () {
      this.isOpen = ! this.isOpen
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Collapsible.vue